import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-14 20:05:03
 * @LastEditTime: 2021-05-17 15:55:37
 * @LastEditors: wangshengqiang
 * @Description: 职业组件
 */
import React, { useEffect, useState } from 'react';
import { getEnumList } from '@/services/dict';
import { getQueryParam } from '@/utils/tool';
import { isPreviewMode, isTemplateMode, isTemplateToolMode } from '@/utils/tool.js';
import RowCascade from '../RowCascade';

function doReturn(item, newList) {
  if (newList.length) {
    item.children = newList;
  }

  return newList.length > 0;
}

const filterCategory = (dataSource, categoryList) => {
  return categoryList.flatMap(item => {
    const {
      children,
      occupationCategory
    } = item;

    if (children !== null && children !== void 0 && children.length) {
      return _objectSpread(_objectSpread({}, item), {}, {
        children: filterCategory(dataSource, children)
      });
    }

    if (dataSource.includes(occupationCategory)) {
      return item;
    }

    return [];
  });
}; // 筛选出指定行业类别的数据


function filter(dataSource, totalList) {
  if (dataSource) {
    dataSource = dataSource.filter(item => item.isDefault).map(item => item.value);

    if (dataSource.length) {
      return filterCategory(dataSource, totalList); // 筛选职业树
    }
  }

  return totalList;
}

function getValueByLevel(level, filterList) {
  const ret = '';

  for (let i = 0; i < filterList.length; i++) {
    const item1 = filterList[i];

    for (let i2 = 0; i2 < item1.children.length; i2++) {
      const item2 = item1.children[i2];

      for (let i3 = 0; i3 < item2.children.length; i3++) {
        const item3 = item2.children[i3];

        for (let i4 = 0; i4 < item3.children.length; i4++) {
          const item4 = item3.children[i4];

          if (Number(level) === Number(item4.value)) {
            // console.log('找到')
            return item4.value;
          }
        }
      }
    }
  }

  return ret;
}

function format(list) {
  const temp = list.map(item => {
    item.label = item.name;
    item.value = item.code;

    if (Array.isArray(item.children)) {
      item.children = format(item.children);
    }

    return item;
  });
  return temp;
}

export default function RowCareer(props) {
  const {
    attrs,
    formKey
  } = props;
  const {
    dataSource
  } = attrs;
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!isTemplateMode() && !isTemplateToolMode() && !isPreviewMode()) {
      const {
        goodsId
      } = getQueryParam();
      getEnumList('occupation', goodsId).then(({
        result,
        success
      }) => {
        if (success) {
          const filterList = format(filter(dataSource, result));
          setList(filterList);
        }
      });
    }
  }, []); // 根据职业类型，筛选职业数据

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RowCascade, _extends({}, props, {
    dataSource: list
  })));
}